import {Injectable} from '@angular/core';
import {urlJoin} from 'src/app/utils/urlJoin';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {Observable} from 'rxjs';

import {map} from 'rxjs/operators';
import {ServerResponse} from 'src/app/domain';

@Injectable({
    providedIn: 'root'
})
export class CertifAchetService {

    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'portail');
    }

    searchCertifAch(searchObject: SearchObject) {
        const resource = urlJoin(CertifAchetService.base, 'vUserInst', 'data');
        return this.http.post(resource, searchObject);
    }

    checkIdRegistre(bizRegNo): Observable<any> {
        const resource = urlJoin(CertifAchetService.base, 'vUserInst/InfoUser?bizRegNo=' + bizRegNo);
        return this.http.get(resource);
    }

    checkListDroits(bizRegNo): Observable<any> {
        const resource = urlJoin(CertifAchetService.base, 'vUserInst/userManager?bizRegNo=' + bizRegNo);
        return this.http.get(resource);
    }

    addCertifAch(f: any) {
        const resource = urlJoin(CertifAchetService.base, 'vUserInst/SaveUser');
        return this.http
            .post<ServerResponse>(resource, f)
            .pipe(map((response) => ({...response} as any)));
    }

    updateCertifAcheteur(f: any) {
        const resource = urlJoin(CertifAchetService.base, 'vUserInst/SaveCert');
        return this.http
            .post<ServerResponse>(resource, f)
            .pipe(map((response) => ({...response} as any)));
    }
}
